import { render, staticRenderFns } from "./EditPwd.vue?vue&type=template&id=82fda98c&scoped=true"
import script from "./EditPwd.vue?vue&type=script&lang=js"
export * from "./EditPwd.vue?vue&type=script&lang=js"
import style0 from "./EditPwd.vue?vue&type=style&index=0&id=82fda98c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fda98c",
  null
  
)

export default component.exports